import { gql } from "@stadium/services/apollo-client";
import { OPTION_VALUES } from "@graphql/fragments/product/option-values";

export const ALL_VARIANTS_DETAILS = gql`
  fragment AllVariantsDetails on CatalogVariants {
    catalogStoreExternalId
    variants {
      id
      externalId
      isMaster
      outOfStock
      catalogVariants(
        catalogExternalStoreProductMappings: $catalogExternalStoreProductMappings
        storeNumber: $storeNumber
      ) {
        images
      }
      amountIn(currency: $currency)
      priceIn(currency: $currency)
      optionValues {
        ...OptionValuesDetails
      }
      vendorByCountry: vendorByCountryOrGlobalZone(country: $country, globalZone: $globalZone) {
        externalId
      }
      images(
        storeNumber: $storeNumber
        catalogExternalStoreProductMappings: $catalogExternalStoreProductMappings
      )
    }
  }
  ${OPTION_VALUES}
`;
